<div 
     class="se-ui-default-text-overlay__expander-resize"
     [ngClass]="{ 'se-ui-default-text-overlay__expander-resize-big': _editingView || _addingNewText}">
    <div class="se-ui-default-text-overlay__expander">
        <div class="se-ui-default-text__background">
            <div class="se-ui-default-text" (keydown.esc)="onClose()">
                <div style="width: 100%; height: 100%">
                    <div class="expander-view__size">
                        <!-- SELECT BY ACCORDION -->
                        <div *ngIf="!_editingView && !_addingNewText && suggestions.length; else noSuggestions">
                            <mat-accordion class="headers-align"
                                           #accordion="matAccordion">
                                <mat-expansion-panel *ngFor="let suggestion of suggestions; index as i;"
                                                     #expansionPanel
                                                     class="se-ui-default-text-option__expander"
                                                     [ngClass]="{'se-ui-default-text-option__expander-open': _showEditOrDeleteButton && suggestion.id === _currentSelection.id}"
                                                     [id]="'suggestion-div-' + i"
                                                     (afterExpand)="_openedAccordion(suggestion, i)"
                                                     (closed)="_closedAccordion()"
                                                     hideToggle>
                                    <mat-expansion-panel-header class="mat-expansion-panel-header">
                                        <mat-panel-title (click)="expPanelToggle($event, i, suggestion)"
                                                         (dblclick)="selPanelDoubleClikc(suggestion, $event)"
                                                         class="mat-expansion-panel-header"
                                                         [ngClass]="{
                                            'mat-expansion-panel-header-title__expanded': _showEditOrDeleteButton,
                                            'se-ui-default-text-option__expander-open':
                                                _showEditOrDeleteButton && suggestion.id === _currentSelection.id
                                        }">
                                            <div style="padding-left:5px;">
                                                <mat-icon [class.predifined-text-no-display]="!_isShared(suggestion)" class="mat-icon"
                                                          aria-hidden="false"
                                                          [matTooltip]="'SharedReport' | translate"
                                                          matTooltipPosition="left"
                                                          matTooltipShowDelay="0">share</mat-icon>
                                            </div>
                                            <div class="standard-icon">
                                                <mat-icon [class.predifined-text-no-display]="!_isStandard(suggestion)" class="mat-icon"
                                                          [ngClass]="{'svg-module-modality': suggestion.standardModules.length > 0 || suggestion.standardModalities.length > 0,
                                                          'svg-standard-predefined-report': suggestion.isStandard }"
                                                          aria-hidden="false"
                                                          svgIcon="STD_icon"
                                                          [matTooltip]="'Standard' | translate"
                                                          matTooltipPosition="left"
                                                          matTooltipShowDelay="0"></mat-icon>
                                            </div>
                                            <div class="mat-expansion-panel-headertitle_content"
                                                 [innerHtml]="createSuggestionHTMLExpanderView(suggestion, i + 1)"
                                                 [matTooltip]="'Open' | translate"
                                                 matTooltipPosition="below"
                                                 matTooltipShowDelay="500">
                                            </div>

                                        </mat-panel-title>

                                        <button class="mat-button se-button-no-ripple"
                                                mat-mini-fab
                                                [matTooltip]="'Add' | translate"
                                                matTooltipPosition="left"
                                                matTooltipShowDelay="0"
                                                (click)="onSelectExpander(suggestion, $event)">
                                            <mat-icon class="mat-icon" aria-hidden="false">add</mat-icon>
                                        </button>
                                    </mat-expansion-panel-header>

                                    <div style="display: flex; justify-content: space-between; padding: 5px; gap: 15px;">
                                        <div *ngFor="let item of suggestion.Sentence | keyvalue" style="flex-grow:1;min-width:300px;"
                                             disabled
                                             (keydown.enter)="onSelectExpander(suggestion, $event)"
                                             (click)="onSelectExpander(suggestion, $event)">
                                            <b>{{ _getTitle(item) | translate }}</b>:
                                            <div class="se-ui-default-text_sentence" [innerHtml]="item.value"></div>
                                        </div>
                                    </div>

                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <!-- EDITING -->
                        <div *ngIf="_editingView || _addingNewText" class="se-ui-default-text-editor_container">
                            <div class="col-6 textarea-style_label se-ui-default-input_container">
                                <div class="col-auto">{{ "Code" | translate }}:</div>

                                <input matInput
                                       type="text"
                                       class="col-auto new-suggestion__header"
                                       [(ngModel)]="_selectedSuggestion.code"
                                       #codeInput="ngModel"
                                       [ngClass]="{ 'error-border': codeInput.invalid }"
                                       required />
                            </div>

                            <div class="col-6 textarea-style_label se-ui-default-input_container">
                                <div class="col-auto">{{ "Description" | translate }}:</div>
                                <input matInput
                                       type="text"
                                       class="col-auto new-suggestion__header"
                                       [(ngModel)]="_selectedSuggestion.Description"
                                       #descriptionInput="ngModel"
                                       [ngClass]="{ 'error-border': descriptionInput.invalid }"
                                       required />
                            </div>
                            <div class="se-text-editor-container">
                                <div class="se-ui-default-input_container se-ui-default-input_text-editor col-24"
                                     *ngFor="let item of _selectedSuggestion.Sentence | keyvalue">
                                    <div class="col-24 textarea-style_label">{{ _getTitle(item) | translate}}:</div>

                                    <se-text-editor class="se-text-editor" [class.se-text-editor-small]="newTextsGroup.size === 1"
                                                    name="se-text-editor"
                                                    [(ngModel)]="item.value"
                                                    [disabled]="false"
                                                    [visible]="true"
                                                    [menuConfig]="_predefinedMenuConfiguration"
                                                    [shortcutList]="_shortcutList"
                                                    [isEditing]="_editingView"
                                                    (contentChange)="contentChange($event, item.key)">
                                        <ng-content extra-buttons-before select="[extra-buttons-before]"></ng-content>
                                    </se-text-editor>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="expander-view__footer">
        <mat-action-row [ngClass]="{ 'expander-view__footer-add': !_addingNewText && !_editingView }"
                        class="expander-view__footer-edit">
            <mat-radio-group *ngIf="!(_editingView || _addingNewText)" (change)="_onSuggestionPolicyChange($event)">
                <mat-radio-button [matTooltip]="'SuggestionPolicyToggleTooltip1' | translate" checked value="0">{{ 'AddText' | translate}}</mat-radio-button>
                <mat-radio-button [matTooltip]="'SuggestionPolicyToggleTooltip2' | translate" value="1">{{ 'ReplaceText' | translate}}</mat-radio-button>
            </mat-radio-group>

            <div *ngIf="!(_editingView || _addingNewText)" class="buttons_container">
                <button class="se-ui-default-text-option__expander-button"
                        mat-raised-button
                        [matTooltip]=" 'Modify' | translate "
                        [disabled]="!_showEditOrDeleteButton"
                        (click)="_onEditClick()">
                    {{'Modify' | translate}}
                </button>
                <button class="se-ui-default-text-option__expander-button se-ui-default-text-option__expander-button-last"
                        mat-raised-button
                        [matTooltip]="'Delete' | translate"
                        [disabled]="!_showEditOrDeleteButton"
                        (click)="_onDeleteClick()">
                    {{'Delete'| translate}}
                </button>

            </div>
            <div class="expander-view__footer-ok" *ngIf="_editingView || _addingNewText">
                <button class="se-ui-default-text-option__expander-button"
                        mat-raised-button
                        [matTooltip]="'Cancel' | translate "
                        (click)="_undoFunction()">
                    {{'Cancel'|translate}}
                </button>
                <button class="se-ui-default-text-option__expander-button se-ui-default-text-option__expander-button-last"
                        mat-raised-button
                        [matTooltip]=" 'Save' | translate "
                        [disabled]="_isOkButtonDisabled()"
                        (click)="_okFunction()">
                    {{'Save'|translate}}
                </button>
            </div>
        </mat-action-row>
    </div>
</div>

<ng-template #noSuggestions>
    <div *ngIf="!_editingView && !_addingNewText" class="se-ui-default-text-nosuggestions">
        <span>
            {{'EmptySuggestions' | translate}}
        </span>
    </div>
</ng-template>
